// extracted by mini-css-extract-plugin
export var blue = "CopyBlock-module--blue--d6629";
export var center = "CopyBlock-module--center--6f1a3";
export var copyBlock = "CopyBlock-module--copyBlock--8ddf7";
export var ctaButton = "CopyBlock-module--ctaButton--4ddbe";
export var dark = "CopyBlock-module--dark--baa3a";
export var enableHeadlineBottomBorder = "CopyBlock-module--enableHeadlineBottomBorder--b0749";
export var headline = "CopyBlock-module--headline--d248c";
export var moduleBackgroundoffWhite = "CopyBlock-module--moduleBackgroundoffWhite--bd76e";
export var moduleBackgroundwhite = "CopyBlock-module--moduleBackgroundwhite--958a1";
export var row3 = "CopyBlock-module--row3--73a54";
export var white = "CopyBlock-module--white--0ecff";